import React, { useState } from 'react';
import {
  Box,
  Collapse,
  IconButton,
  makeStyles,
  Table, TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import {TrafficShapingStatus} from "../../../Domain/Models/TrafficShapingStatus";
import ErrorCardController from "../../UiComponents/ErrorCardController";
import CubeMatchingEntry from "../../../Domain/Models/CubeMatchingEntry";
import {Group as GroupIcon} from "@material-ui/icons";
import Cube from "../../../Domain/Models/Cube";
import Group from "../../../Domain/Models/Group";
import {KeyboardArrowDown, KeyboardArrowUp} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  title: {
    flexGrow: 1
  },
  clickableCell: {
    cursor: 'pointer',
  },
}));

export interface QueueListRowProps
{
  idVisible: boolean;
  cubeMatchingEntry: CubeMatchingEntry;
  handleAdmitToQueueLineClicked: (cube: Cube, group: Group) => void;
}

export default function QueueListRow(props: QueueListRowProps)
{
  const {cubeMatchingEntry, idVisible, handleAdmitToQueueLineClicked} = props;

  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow key={cubeMatchingEntry.id} hover>
        <TableCell>
          <IconButton
          aria-label="expand row"
          size="small"
          onClick={() => setOpen(!open)}
        >
          {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </IconButton>
        </TableCell>
        {idVisible && <TableCell scope="row">{cubeMatchingEntry.id}</TableCell>}
        <TableCell>{cubeMatchingEntry.group.playerPairs.map(x => x.name).join(' vs. ')}</TableCell>
        <TableCell>{new Date(cubeMatchingEntry.entryTime).toLocaleTimeString()}</TableCell>
        <TableCell>{new Date(cubeMatchingEntry.earliestMatchTime).toLocaleTimeString()}</TableCell>
        <TableCell>{cubeMatchingEntry.matchedCube ? new Date(cubeMatchingEntry.matchTime).toLocaleTimeString() : ''}</TableCell>
        <TableCell>{cubeMatchingEntry.matchedCube?.name}</TableCell>
        <TableCell>
          {cubeMatchingEntry.matchedCube && (
            <IconButton size="small" color="default"
                        onClick={() => handleAdmitToQueueLineClicked(cubeMatchingEntry.matchedCube, cubeMatchingEntry.group)}>
              <GroupIcon/>
            </IconButton>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              <Typography variant="h6" gutterBottom component="h3">
                Success Route Cubes
              </Typography>
              <Table size="small">
                <TableBody>
                  {cubeMatchingEntry.successRouteCubes.map(x => (
                    <TableRow key={`${cubeMatchingEntry.id}_${x.id}`}>
                      <TableCell>
                        {x.name}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}